module.exports = __webpack_public_path__ + "img/sld_mfm_crp_b1_dark.1cea221f.svg";